import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NkDatatableAbstractColumnComponent } from '@nk/ui-lib';
import { map } from 'rxjs/operators';
import { AccountsNumberPipe } from '../../pipes/accounts-number.pipe';

@Component({
  selector: 'nk-accounts-number-column',
  imports: [NgIf, AccountsNumberPipe, AsyncPipe],
  templateUrl: './accounts-number-column.component.html',
  styleUrls: ['./accounts-number-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountsNumberColumnComponent<T> extends NkDatatableAbstractColumnComponent<T> {
  public data$ = this.value$.pipe(
    map((value) => {
      const num = value && value.prop && value.row && value.row[value.prop];
      return typeof num === 'number' ? num : null;
    }),
  );
}
